import {Api} from '../../../Api.js'

const RESOURCE = 'giftcard'

export default {
    resource: RESOURCE,
    prefix: 'shop/',
    all(query) {
        return Api().get(this.prefix + this.resource + '/all'  + (query ? query : '') )
    },
    transactions(id) {
        return Api().get(this.prefix + this.resource + '/transactions' + '/' + id)
    },
    generate() {
        return Api().post(this.prefix + this.resource + '/generate')
    },
    query(query) {
        return Api().get(this.prefix + this.resource + (query ? query : ''))
    },
    get(id) {
        return Api().get(this.prefix + this.resource + '/' + id)
    },
    create(data) {
        return Api().post(this.prefix + this.resource, data)
    },
    update(id, data) {
        return Api().put(this.prefix + this.resource + '/' + id, data)
    },
    delete(id) {
        return Api().delete(this.prefix + this.resource + '/' + id)
    },
    forceDelete(id) {
        return Api().delete(this.prefix + this.resource + '/force-delete/' + id)
    },
    restore(id) {
        return Api().post(this.prefix + this.resource + '/restore/' + id)
    },
    duplicate(id) {
        return Api().get(this.prefix + this.resource + '/duplicate/' + id)
    }
}


// WEBPACK FOOTER //
// ./src/modules/shop/giftcard/GiftcardService.js